webpackJsonp([60],{

/***/ 1058:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1059);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("e48e17d4", content, true, {});

/***/ }),

/***/ 1059:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".search-wrapper-peak-period[data-v-44835675]{position:relative;width:100%;margin-bottom:20px}.search-wrapper-peak-period input[data-v-44835675]{display:inline-block;width:100%;position:relative;border-collapse:separate;border:1px solid #ccc;border-radius:5px;padding-left:43px;-webkit-box-shadow:none;box-shadow:none}.search-wrapper-peak-period i[data-v-44835675]{color:#ccc;padding:0 15px;position:absolute;left:0;z-index:2;font-size:1.2rem;top:9px}", "", {"version":3,"sources":["/app/src/components/master/peakPeriod/PeakPeriod.vue"],"names":[],"mappings":"AACA,6CACE,kBAAmB,AACnB,WAAY,AACZ,kBAAoB,CACrB,AACD,mDACE,qBAAsB,AACtB,WAAY,AACZ,kBAAmB,AACnB,yBAA0B,AAC1B,sBAAuB,AACvB,kBAAmB,AACnB,kBAAmB,AACnB,wBAAyB,AACjB,eAAiB,CAC1B,AACD,+CACE,WAAY,AACZ,eAAgB,AAChB,kBAAmB,AACnB,OAAQ,AACR,UAAW,AACX,iBAAkB,AAClB,OAAS,CACV","file":"PeakPeriod.vue","sourcesContent":["\n.search-wrapper-peak-period[data-v-44835675] {\n  position: relative;\n  width: 100%;\n  margin-bottom: 20px;\n}\n.search-wrapper-peak-period input[data-v-44835675] {\n  display: inline-block;\n  width: 100%;\n  position: relative;\n  border-collapse: separate;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding-left: 43px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.search-wrapper-peak-period i[data-v-44835675] {\n  color: #ccc;\n  padding: 0 15px;\n  position: absolute;\n  left: 0;\n  z-index: 2;\n  font-size: 1.2rem;\n  top: 9px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1060:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container big-container"},[_c('div',{staticClass:"row mt-20"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"mini-form"},[_c('ul',{staticClass:"nav nav-tabs nav-justified tabs-mini-form"},[_c('li',{staticClass:"active"},[_c('a',{ref:"linkrange",attrs:{"href":"#range","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'range'}}},[_vm._v("\n                  Range\n                ")])]),_vm._v(" "),_c('li',[_c('a',{ref:"linkflex",attrs:{"href":"#flex","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'flex'}}},[_vm._v("\n                  Flex\n                ")])]),_vm._v(" "),_c('li',[_c('a',{ref:"linkannual",attrs:{"href":"#annual","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'annual'}}},[_vm._v("\n                  Annual\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"range"}},[(_vm.activeTab.toLowerCase() === 'range')?_c('div',[_vm._m(0),_vm._v(" "),_c('form',{attrs:{"action":"#","id":"peak-period-form","role":"form"}},[_c('div',{staticClass:"form-group w60"},[_vm._m(1),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD","range":"","auto-close":"","no-shortcuts":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.model.dateRange),callback:function ($$v) {_vm.$set(_vm.model, "dateRange", $$v)},expression:"model.dateRange"}}),_vm._v(" "),(_vm.validationErrors.dateRange)?_c('small',{staticClass:"form-text text-danger",domProps:{"textContent":_vm._s(_vm.validationErrors.dateRange)}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Event Title")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"}],staticClass:"form-control",attrs:{"rows":"3","name":"title","maxlength":"100","required":""},domProps:{"value":(_vm.model.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "title", $event.target.value)}}}),_vm._v(" "),(_vm.validationErrors.title)?_c('small',{staticClass:"form-text text-danger",domProps:{"textContent":_vm._s(_vm.validationErrors.title)}}):_vm._e(),_vm._v(" "),(
                          _vm.model.title !== null && _vm.model.title !== undefined
                        )?_c('div',{staticClass:"text-right word-count"},[_vm._v("\n                        "+_vm._s(_vm.model.title.length)+" from 100 characters\n                      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer pt-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary pull-left",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.saveItem()}}},[_vm._v("\n                            Save Period Date\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-default pull-right",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.resetModel()}}},[_vm._v("\n                            Reset\n                          ")])])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"flex"}},[(_vm.activeTab.toLowerCase() === 'flex')?_c('div',[_vm._m(2),_vm._v(" "),_c('form',{attrs:{"action":"#","id":"peak-period-form","role":"form"}},[_vm._l((_vm.flexDates),function(input,index){return _c('div',{key:index,staticClass:"form-group"},[(index === 0)?_c('label',[_vm._v("Select Date")]):_c('label',[_vm._v("Other Date")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9 prz"},[_c('VueCtkDateTimePicker',{attrs:{"id":index,"color":"#025BC5","format":"YYYY-MM-DD","formatted":"LL","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(input.startDate),callback:function ($$v) {_vm.$set(input, "startDate", $$v)},expression:"input.startDate"}})],1),_vm._v(" "),(_vm.flexDates.length > 1)?_c('div',{staticClass:"col-sm-3 text-center"},[_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteFlex(index)}}},[_c('i',{staticClass:"ic-close"})])]):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"btn btn-flat mb-25",on:{"click":function($event){return _vm.addFlex()}}},[_vm._v("\n                      + Add dates\n                    ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Event Title")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"}],staticClass:"form-control",attrs:{"rows":"3","name":"title","maxlength":"100","required":""},domProps:{"value":(_vm.model.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "title", $event.target.value)}}}),_vm._v(" "),(_vm.validationErrors.title)?_c('small',{staticClass:"form-text text-danger",domProps:{"textContent":_vm._s(_vm.validationErrors.title)}}):_vm._e(),_vm._v(" "),(
                          _vm.model.title !== null && _vm.model.title !== undefined
                        )?_c('div',{staticClass:"text-right word-count"},[_vm._v("\n                        "+_vm._s(_vm.model.title.length)+" from 100 characters\n                      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer pt-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary pull-left",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.saveItem()}}},[_vm._v("\n                            Save Date\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-default pull-right",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.resetModel()}}},[_vm._v("\n                            Reset\n                          ")])])])])],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"annual"}},[(_vm.activeTab.toLowerCase() === 'annual')?_c('div',[_vm._m(3),_vm._v(" "),_c('form',{attrs:{"action":"#","id":"peak-period-form","role":"form"}},[_c('div',{staticClass:"form-group w60"},[_c('label',[_vm._v("Select Date")]),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"color":"#025BC5","format":"YYYY-MM-DD","formatted":"LL","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.model.startDate),callback:function ($$v) {_vm.$set(_vm.model, "startDate", $$v)},expression:"model.startDate"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Holiday / Event Title")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"}],staticClass:"form-control",attrs:{"rows":"3","name":"title","maxlength":"100","required":""},domProps:{"value":(_vm.model.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "title", $event.target.value)}}}),_vm._v(" "),(_vm.validationErrors.title)?_c('small',{staticClass:"form-text text-danger",domProps:{"textContent":_vm._s(_vm.validationErrors.title)}}):_vm._e(),_vm._v(" "),(
                          _vm.model.title !== null && _vm.model.title !== undefined
                        )?_c('div',{staticClass:"text-right word-count"},[_vm._v("\n                        "+_vm._s(_vm.model.title.length)+" from 100 characters\n                      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer pt-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary pull-left",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.saveItem()}}},[_vm._v("\n                            Save Annual Date\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-default pull-right",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.resetModel()}}},[_vm._v("\n                            Reset\n                          ")])])])])])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',[_c('div',{staticClass:"event-calendar-header",staticStyle:{"border-top":"unset"}},[_c('div',{staticClass:"row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-7 pull-right"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"search-wrapper-peak-period"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchFilter),expression:"searchFilter"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search Title/Event"},domProps:{"value":(_vm.searchFilter)},on:{"keyup":function($event){return _vm.onSearchTitle()},"input":function($event){if($event.target.composing){ return; }_vm.searchFilter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Select month","label":"text","options":_vm.months,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},on:{"input":function($event){return _vm.onChangeFilter()}},model:{value:(_vm.monthFilter),callback:function ($$v) {_vm.monthFilter=$$v},expression:"monthFilter"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Select year","label":"","options":_vm.years,"clearable":true,"searchable":true,"filterable":true},on:{"input":function($event){return _vm.onChangeFilter()}},model:{value:(_vm.yearFilter),callback:function ($$v) {_vm.yearFilter=$$v},expression:"yearFilter"}})],1)])])])])]),_vm._v(" "),_c('table',{staticClass:"table table-hover mtz"},[_vm._m(5),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:index,staticClass:"detail-row"},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.typeDescription))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.printDate(item)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateItem(item)}}},[_c('span',[_vm._v("Edit")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item)}}},[_c('i',{staticClass:"ic-close"})])])])])}),0)])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-pickperiod"},[_vm._v("\n                    Add periodic dates\n                    "),_c('span',[_vm._v("\n                      This feature is used to manage peak periods with a start\n                      and end date (date range) scheme.\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("\n                        Select Date\n                        "),_c('span',{staticClass:"--blue25"},[_vm._v("( in Range )")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-pickperiod"},[_vm._v("\n                    Add flex dates\n                    "),_c('span',[_vm._v("\n                      This feature is used to manage peak periods with\n                      flexible date scheme.\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-pickperiod"},[_vm._v("\n                    Add annual dates\n                    "),_c('span',[_vm._v("\n                      This feature is used to manage peak periods for\n                      recurring dates every years.\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-5"},[_c('h3',[_vm._v("Event Calendar")]),_vm._v(" "),_c('p',{staticClass:"info-text"},[_vm._v("\n                    Annual day may differ by other countries.\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Title / Event")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeakPeriod_vue__ = __webpack_require__(795);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44835675_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeakPeriod_vue__ = __webpack_require__(1060);
function injectStyle (ssrContext) {
  __webpack_require__(1058)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44835675"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeakPeriod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44835675_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeakPeriod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    idModal: {
      type: String,
      default: "deletemodal"
    },
    subContent: {
      type: String,
      default: "Do you want to delete this record? This process cannot be undone."
    }
  },
  methods: {
    cancel: function cancel() {
      $("#" + this.idModal).modal("hide");
      this.$emit("cancel");
    },
    submit: function submit() {
      $("#" + this.idModal).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__ = __webpack_require__(492);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.idModal}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[_vm._m(0),_vm._v(" "),_c('header',[_vm._v("Are you sure?")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.subContent)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                  Cancel\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  Yes, delete\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-icon"},[_c('i',{staticClass:"ic-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/master/peakPeriods";

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/list").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllByFilter: function getAllByFilter(month, year, search) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/list/filter?month=" + month + "&year=" + year + "&search=" + search)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllById: function getAllById(id) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/list/" + id)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  create: function create(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  update: function update(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ("/" + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_DeleteModal__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_master_peakPeriod_peakPeriodService_js__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_3__components_shared_DeleteModal__["a" /* default */]
  },
  data: function data() {
    return {
      validationErrors: {
        dateRange: null,
        title: null
      },
      months: [],
      years: [],
      searchFilter: "",
      monthFilter: null,
      yearFilter: null,
      flexDates: [],
      activeTab: "range",
      itemToBeDeleted: null,
      minimumEndDate: null,
      items: [],
      model: {},
      isLoading: false,
      msg: "Please wait"
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var dateNow, previousYear, i;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _this.$helper.scrollTop();
              _this.isLoading = true;
              dateNow = new Date();
              // this.monthFilter = dateNow.getMonth() + 1;
              // this.yearFilter = dateNow.getFullYear();

              _this.months = [];
              _this.months.push({ text: "January", value: 1 });
              _this.months.push({ text: "February", value: 2 });
              _this.months.push({ text: "March", value: 3 });
              _this.months.push({ text: "April", value: 4 });
              _this.months.push({ text: "May", value: 5 });
              _this.months.push({ text: "June", value: 6 });
              _this.months.push({ text: "July", value: 7 });
              _this.months.push({ text: "August", value: 8 });
              _this.months.push({ text: "September", value: 9 });
              _this.months.push({ text: "October", value: 10 });
              _this.months.push({ text: "November", value: 11 });
              _this.months.push({ text: "December", value: 12 });
              _this.years = [];
              previousYear = dateNow.getFullYear() - 1;

              for (i = 0; i <= 10; i++) {
                _this.years.push(previousYear + i);
              }
              _this.minimumEndDate = _this.$helper.toStringDate(_this.$helper.addDays(0));
              _this.resetModel();
              _context.next = 24;
              return _this.getAll();

            case 24:
              _context.prev = 24;

              _this.isLoading = false;
              return _context.finish(24);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0,, 24, 27]]);
    }))();
  },
  updated: function updated() {
    this.$helper.collapseMenu("administration");
    this.$helper.setNavigationClass("public-holiday-link");
    var self = this;
    $(".startDate-holiday-wrapper .datepicker-day").on("click", function () {
      self.minimumEndDate = self.model.startDate;
    });
  },

  methods: {
    onSearchTitle: function onSearchTitle() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                self = _this2;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return self.getAll();

                          case 2:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    printDate: function printDate(item) {
      switch (item.typeDescription.toLowerCase()) {
        case "range":
          return __WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date(item.startDate)).format("ll") + " - " + __WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date(item.endDate)).format("ll");
        case "flex":
          return __WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date(item.startDate)).format("ll");
        case "annual":
          var newDate = new Date(item.startDate);
          newDate.setFullYear(this.yearFilter);
          return __WEBPACK_IMPORTED_MODULE_5_moment___default()(newDate).format("ll");
        default:
          return "";
      }
    },
    addFlex: function addFlex() {
      this.flexDates.push({
        startDate: "",
        groupId: null,
        id: null
      });
    },
    deleteFlex: function deleteFlex(index) {
      this.flexDates.splice(index, 1);
    },
    resetModel: function resetModel() {
      this.resetValidations();
      this.model = {};
      this.flexDates = [];
      this.addFlex();
    },
    resetValidations: function resetValidations() {
      this.validationErrors.dateRange = null;
      this.validationErrors.title = null;
    },
    createItem: function createItem() {
      this.resetModel();
    },
    updateItem: function updateItem(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var peakPeriods, i, newDate;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.resetValidations();
                _this3.activeTab = item.typeDescription.toLowerCase();
                _context4.t0 = _this3.activeTab;
                _context4.next = _context4.t0 === "range" ? 5 : 7;
                break;

              case 5:
                item.dateRange = {
                  start: item.startDate,
                  end: item.endDate
                };
                return _context4.abrupt("break", 7);

              case 7:
                _this3.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
                _this3.minimumEndDate = item.startDate;
                _context4.t1 = _this3.activeTab;
                _context4.next = _context4.t1 === "range" ? 12 : _context4.t1 === "flex" ? 14 : _context4.t1 === "annual" ? 21 : 26;
                break;

              case 12:
                $(_this3.$refs.linkrange).click();
                return _context4.abrupt("break", 26);

              case 14:
                _context4.next = 16;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_peakPeriod_peakPeriodService_js__["a" /* default */].getAllById(item.id);

              case 16:
                peakPeriods = _context4.sent;

                _this3.flexDates = [];
                for (i = 0; i < peakPeriods.length; i++) {
                  _this3.flexDates.push({
                    startDate: peakPeriods[i].startDate,
                    groupId: peakPeriods[i].groupId,
                    id: peakPeriods[i].id
                  });
                }
                $(_this3.$refs.linkflex).click();
                return _context4.abrupt("break", 26);

              case 21:
                newDate = new Date(_this3.model.startDate);

                newDate.setFullYear(new Date().getFullYear());
                _this3.model.startDate = newDate.getFullYear() + "-" + (newDate.getMonth() + 1) + "-" + newDate.getDate();
                $(_this3.$refs.linkannual).click();
                return _context4.abrupt("break", 26);

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    onChangeFilter: function onChangeFilter() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this4.getAll();

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    getAll: function getAll() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this5.isLoading = true;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_peakPeriod_peakPeriodService_js__["a" /* default */].getAllByFilter(_this5.monthFilter, _this5.yearFilter, _this5.searchFilter);

              case 4:
                _this5.items = _context6.sent;

              case 5:
                _context6.prev = 5;

                _this5.isLoading = false;
                return _context6.finish(5);

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5, [[0,, 5, 8]]);
      }))();
    },
    saveItem: function saveItem() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var isUpdate, i, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (_this6.$helper.validateForm(_this6, "peak-period-form")) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                _context7.prev = 2;

                _this6.isLoading = true;
                isUpdate = !!_this6.model.id;
                _context7.t0 = _this6.activeTab;
                _context7.next = _context7.t0 === "range" ? 8 : _context7.t0 === "flex" ? 13 : _context7.t0 === "annual" ? 19 : 23;
                break;

              case 8:
                _this6.model.type = 1;
                _this6.model.startDateCommand = _this6.$helper.fixDateTime(_this6.model.dateRange.start);
                _this6.model.endDateCommand = _this6.$helper.fixDateTime(_this6.model.dateRange.end);
                delete _this6.model.flexDatesCommand;
                return _context7.abrupt("break", 23);

              case 13:
                _this6.model.type = 2;
                delete _this6.model.startDateCommand;
                delete _this6.model.endDateCommand;
                _this6.model.flexDatesCommand = [];
                for (i = 0; i < _this6.flexDates.length; i++) {
                  _this6.model.flexDatesCommand.push({
                    id: _this6.flexDates[i].id,
                    groupId: _this6.flexDates[i].groupId,
                    startDate: _this6.$helper.fixDateTime(_this6.flexDates[i].startDate)
                  });
                }
                return _context7.abrupt("break", 23);

              case 19:
                _this6.model.type = 3;
                _this6.model.startDateCommand = _this6.$helper.fixDateTime(_this6.model.startDate);
                delete _this6.model.endDateCommand;
                return _context7.abrupt("break", 23);

              case 23:
                if (!isUpdate) {
                  _context7.next = 29;
                  break;
                }

                _context7.next = 26;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_peakPeriod_peakPeriodService_js__["a" /* default */].update(_this6.model);

              case 26:
                _this6.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context7.next = 32;
                break;

              case 29:
                _context7.next = 31;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_peakPeriod_peakPeriodService_js__["a" /* default */].create(_this6.model);

              case 31:
                _this6.$notification.success("Successfully added.", {
                  title: "Success"
                });

              case 32:
                _this6.resetModel();
                _context7.next = 35;
                return _this6.getAll();

              case 35:
                _context7.next = 40;
                break;

              case 37:
                _context7.prev = 37;
                _context7.t1 = _context7["catch"](2);

                if (_context7.t1.errors) {
                  for (index = 0; index < _context7.t1.errors.length; index++) {
                    _this6.$notification.error(_context7.t1.errors[index], { title: "Error" });
                  }
                }

              case 40:
                _context7.prev = 40;

                _this6.isLoading = false;
                return _context7.finish(40);

              case 43:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6, [[2, 37, 40, 43]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this7.isLoading = true;
                item.startDateCommand = _this7.$helper.fixDateTime(item.stringStartDate);
                item.endDateCommand = _this7.$helper.fixDateTime(item.stringEndDate);
                _context8.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_peakPeriod_peakPeriodService_js__["a" /* default */].update(item);

              case 6:
                _this7.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context8.next = 9;
                return _this7.getAll();

              case 9:
                _context8.next = 14;
                break;

              case 11:
                _context8.prev = 11;
                _context8.t0 = _context8["catch"](0);

                if (_context8.t0.errors) {
                  for (index = 0; index < _context8.t0.errors.length; index++) {
                    _this7.$notification.error(_context8.t0.errors[index], { title: "Error" });
                  }
                }

              case 14:
                _context8.prev = 14;

                _this7.isLoading = false;
                return _context8.finish(14);

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7, [[0, 11, 14, 17]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    submitDelete: function submitDelete() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                _this8.isLoading = true;
                _context9.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_peakPeriod_peakPeriodService_js__["a" /* default */].delete(_this8.itemToBeDeleted.id);

              case 4:
                _this8.$notification.success("Successfully deleted.", {
                  title: "Success"
                });
                _context9.next = 7;
                return _this8.getAll();

              case 7:
                _context9.next = 12;
                break;

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9["catch"](0);

                if (_context9.t0.errors) {
                  for (index = 0; index < _context9.t0.errors.length; index++) {
                    _this8.$notification.error(_context9.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context9.prev = 12;

                _this8.isLoading = false;
                return _context9.finish(12);

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this8, [[0, 9, 12, 15]]);
      }))();
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/60.1741a5cf286c13142cb7.js